window.inScroll = function () {
    let sectionSelect = window.searchSection();
    if (sectionSelect && sectionSelect.hasAttribute('data-bg')) {
        let colorFirst = window.findColor(sectionSelect.getAttribute('data-bg'));
        if (colorFirst) {
            if (innerWidth > 991) {
                if (sectionSelect.nextElementSibling && sectionSelect.nextElementSibling.hasAttribute('data-bg')) {
                    let rct = sectionSelect.getBoundingClientRect();
                    let h = rct.top + rct.height;
                    let hh = (h / rct.height)
                    let colorLast = window.findColor(sectionSelect.nextElementSibling.getAttribute('data-bg'));
                    if (colorLast) {
                        if (hh < 0.5) {
                            for (let index in colorLast) {
                                sectionSelect.style.setProperty(index, colorLast[index]);
                                sectionSelect.nextElementSibling.style.setProperty(index, colorLast[index]);
                                // sectionSelect.style.setProperty(index, window.colorGradient(colorFirst[index], colorLast[index], h / rct.height));
                                // sectionSelect.nextElementSibling.style.setProperty(index, window.colorGradient(colorFirst[index], colorLast[index], h / rct.height));
                            }
                        } else {
                            for (let index in colorFirst) {
                                sectionSelect.style.setProperty(index, colorFirst[index]);
                                sectionSelect.nextElementSibling.style.setProperty(index, colorFirst[index]);
                            }
                        }
                    }
                } else {
                    for (let index in colorFirst) {
                        sectionSelect.style.setProperty(index, colorFirst[index]);
                    }
                }
            } else {
                for (let index in colorFirst) {
                    sectionSelect.style.setProperty(index, colorFirst[index]);
                }
            }
        }
    }
}

window.stepscroll = function (career_page_steps) {
    if (career_page_steps) {
        if (innerWidth > 991) {
            let stepslist = career_page_steps.querySelector(".steps-list .steps");
            let rect = career_page_steps.parentElement.parentElement.getBoundingClientRect();
            let rect_fx = career_page_steps.getBoundingClientRect();
            let y = (rect.top - rect_fx.top);
            let yh = (rect.top + rect.height) - (rect_fx.top + rect_fx.height);
            if (y < 0) y = 0;
            if (yh < 0) yh = 0;

            career_page_steps.style.setProperty('clip-path', `polygon(0 ${y}px, 100% ${y}px, 100% ${yh}px, 0 ${yh}px)`);
            let yu = (-rect.top) * document.body.offsetHeight / rect.height;
            let vy = yu * (career_page_steps.scrollHeight + stepslist.offsetHeight) / rect.height;
            stepslist.scrollTop = vy;
            stepslist.parentElement.previousElementSibling.children[0].innerHTML = "0" + Number(Math.round(stepslist.scrollTop / stepslist.offsetHeight) + 1);
        } else {
            career_page_steps.style.removeProperty('clip-path');

        }
    }
}
let tabs = document.querySelector(".services-page .tabs")
let tabbuttons = document.querySelector(".services-page .tab-buttons")

let tabcontents = document.querySelectorAll(".services-page .tab-services .tab-content>.tab-content-item .card-one-list>.card-one-item");
let tabcontents_p = document.querySelectorAll(".services-page .tab-services .tab-content>.tab-content-item");
let contentselect = null;
let indexselect = 0;
if (tabcontents && tabcontents.length) {
    if (location.hash) {
        contentselect = tabcontents[location.hash.slice(1)];
        let tab_scroll = tabcontents_p[location.hash.slice(1)].getBoundingClientRect();
        let y = tab_scroll.top + scrollY - 147;
        $("html, body").animate({ scrollTop: y });

    } else {
        contentselect = tabcontents[0];
    }
}
let contentselectbk = contentselect;
let stickyshapebg = document.querySelector("#sticky-shape-bg svg path");
window.scrollShape = function () {
    if (tabcontents && tabcontents.length) {
        tabcontents.forEach((tabcontent, index) => {
            let rect_tabcontent = tabcontent.getBoundingClientRect();
            if (rect_tabcontent.top < (innerHeight / 2 - 72)) {
                contentselect = tabcontent;
                indexselect = index;
            }
            let shape = contentselect.querySelector(".card-one-item .card-one-shape .sticky-shape");
            if (shape) {
                shape.style.transition = "0.5s opacity";
                shape.classList.remove('fixed')
            }
        });
        if (contentselect) {
            tabbuttons.classList.remove('gray');
            tabbuttons.classList.remove('white');
            switch (getComputedStyle(contentselect.parentElement.parentElement.parentElement).backgroundColor) {
                case "rgb(241, 241, 243)": tabbuttons.classList.add('gray'); break;
                case "rgba(0, 0, 0, 0)": tabbuttons.classList.add('white'); break;

            }

            if (tabbuttons.children[indexselect]) {
                window.tabClick(tabs, tabbuttons.children[indexselect], tabcontents[indexselect], true);
            }

            let shape = contentselect.querySelector(".card-one-item .card-one-shape .sticky-shape");
            if (shape) {
                stickyshapebg.style.setProperty('fill', shape.getAttribute('data-color'));
                let rect_share_scroll = shape.parentElement.getBoundingClientRect();
                let y = scrollY - (rect_share_scroll.top + scrollY);
                let v = (innerHeight / 2 - shape.offsetHeight / 2);
                y += v;
                shape.classList.add('fixed')
                stickyshapebg.style.setProperty('display', '');
                if (indexselect == 0) {
                    if (y < 0) {
                        y = 0;
                        shape.classList.remove('fixed');
                        stickyshapebg.style.setProperty('display', 'none');
                    }
                }
                if (indexselect == tabcontents.length - 1) {
                    if (y > 0) { y = 0; shape.classList.remove('fixed'); stickyshapebg.style.setProperty('display', 'none'); }
                }
                shape.style.opacity = 1;
            }
        }
        if (contentselectbk && contentselectbk != contentselect) {
            let shape = contentselectbk.querySelector(".card-one-item .card-one-shape .sticky-shape");
            if (shape) {
                shape.style.transition = "";
                shape.style.opacity = '';
                shape.classList.remove('fixed');
                stickyshapebg.style.setProperty('display', 'none');

            }
        }
        contentselectbk = contentselect;
    }
}


window.scrollButtonTab = function () {
    if (tabs && tabbuttons) {
        let rect_tabs = tabs.getBoundingClientRect();
        let rect_tabbuttons = tabbuttons.getBoundingClientRect();
        if (rect_tabs.top < 147) {
            tabbuttons.classList.add('fixed')
        } else {
            tabbuttons.classList.remove('fixed')
        }
        // console.log(rect_tabbuttons.top + rect_tabbuttons.height + scrollY, rect_tabs.height + rect_tabs.top + scrollY)
        if ((rect_tabbuttons.top + rect_tabbuttons.height + scrollY) >= (rect_tabs.height + rect_tabs.top + scrollY)) {
            tabbuttons.style.zIndex = '-1'
        } else {
            tabbuttons.style.zIndex = ''

        }
    }
}


// WEBPACK FOOTER //
// ./scripts/scroll.js